<div
  class="min-h-screen flex flex-col items-center justify-center md:items-start md:justify-start py-10 md:px-24 px-8"
>
  <h1
    class="md:text-4xl font-semibold font-inter mb-6 text-center hidden md:block"
  >
    Страницата не е намерена
  </h1>

  <div
    class="flex flex-col md:flex-row items-center md:items-start border-4 md:border-2 border-extraError rounded-lg bg-[#ff7d7d3e] max-w-auto w-full py-8 px-4"
  >
    <div
      class="flex-shrink-0 mb-4 md:mb-0 md:mr-4 flex items-center justify-center"
    >
      <img
        src="assets/page-not-found.svg"
        alt="No bike icon"
        class="w-28 h-28 block md:hidden"
      />
      <img
        src="assets/warning.svg"
        alt="No bike icon"
        class="w-12 h-12 hidden md:block mt-1"
      />
    </div>

    <div class="flex flex-col space-y-2">
      <p class="text-extraError font-semibold font-inter md:text-xl text-base">
        За съжаление страницата, която търсите, не може да бъде намерена. <br />
        Съжаляваме, за причиненото неудобство.
      </p>
    </div>
  </div>
</div>
